import { useCallback, useEffect, useState } from 'react';
import {
  applyThemePreference,
  persistThemePreference,
  readStoredTheme,
  type ThemePreference,
} from './themeStorage';

export type { ThemePreference };

export function useTheme(): {
  preference: ThemePreference;
  setTheme: (next: ThemePreference) => void;
} {
  const [preference, setPreference] = useState<ThemePreference>(() => readStoredTheme());

  useEffect(() => {
    applyThemePreference(preference);
  }, [preference]);

  const setTheme = useCallback((next: ThemePreference) => {
    persistThemePreference(next);
    applyThemePreference(next);
    setPreference(next);
  }, []);

  return { preference, setTheme };
}
